import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "@livekit/components-styles";
import "./styles.css";

import { NewRoom } from "./pages/NewRoom";
import { Room } from "./pages/Room";

const router = createBrowserRouter([
  { path: "/", element: <NewRoom /> },
  { path: "/r/:code", element: <Room /> },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
